import React from 'react'
import { Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { Tabs, Tab } from 'react-bootstrap';
import { useState } from 'react';
import NumberFormat from 'react-number-format';
import Pagination from 'react-bootstrap-4-pagination';
import BanDoThichHopApi from '../../api/BanDoThichHopApi';



export const TimKiemThichHopDatDai = (props) => {
    const { register, handleSubmit } = useForm();
    const [listKetQuas, setKetQua] = useState([]);
    const [tongRow, setTongRow] = useState(-1);
    const [tongDienTich, setTongDienTich] = useState(0);
    let query = '';
    let pageIndex = 1;
    const timKiem = (data) => {
        query = getSql(data);
        props.timKiem(query);
        loadDuLieu();
    }
    const getSql = (data) => {
        let sql = '';
        if (data.DienTichMin !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"dt_ha" ${data.DienTichDieuKienMin} ${data.DienTichMin}`
        }
        if (data.DienTichMax !== "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"dt_ha" ${data.DienTichDieuKienMax} ${data.DienTichMax}`
        }
        if (data.ThLua != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"lua" like '${data.ThLua}'`
        }
        if (data.ThNgo != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"ngo" like '${data.ThNgo}'`
        }
        if (data.ThSan != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"san" like '${data.ThSan}'`
        }
        if (data.ThKhoai != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"khoai" like '${data.ThKhoai}'`
        }
        if (data.ThRau != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"rau" like '${data.ThRau}'`
        }
        if (data.ThBi != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"bi" like '${data.ThBi}'`
        }
        if (data.ThLac != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"lac" like '${data.ThLac}'`
        }
        if (data.ThHoa != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"hoa" like '${data.ThHoa}'`
        }

        if (data.ThCam != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"cam" like '${data.ThCam}'`
        }
        if (data.ThBuoi != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"buoi" like '${data.ThBuoi}'`
        }
        if (data.ThChanh != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"chanh_day" like '${data.ThChanh}'`
        }
        if (data.ThNhan != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"nhan" like '${data.ThNhan}'`
        }

        if (data.ThMit != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"mit" like '${data.ThMit}'`
        }
        if (data.ThBo != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"bo" like '${data.ThBo}'`
        }
        if (data.ThSauRieng != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"sau_rieng" like '${data.ThSauRieng}'`
        }
        if (data.ThXoai != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"xoai" like '${data.ThXoai}'`
        }

        if (data.ThNa != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"na" like '${data.ThNa}'`
        }
        if (data.ThChuoi != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"chuoi" like '${data.ThChuoi}'`
        }
        if (data.ThDieu != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"dieu" like '${data.ThDieu}'`
        }
        if (data.ThCaoSu != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"cao_su" like '${data.ThCaoSu}'`
        }
        if (data.ThTieu != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"ho_tieu" like '${data.ThTieu}'`
        }
        if (data.ThCafe != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"caffe" like '${data.ThCafe}'`
        }
        if (data.ThDauTam != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"dau_tam" like '${data.ThDauTam}'`
        }
        if (data.ThMang != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"mang_tay" like '${data.ThMang}'`
        }
        if (data.ThDuoc != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"duoc_lieu" like '${data.ThDuoc}'`
        }
        if (data.ThDua != "") {
            sql = sql.length > 0 ? sql + ' AND ' : '';
            sql = sql + `"dua" like '${data.ThDua}'`
        }
        if (sql !== '') {
            sql = props.queryHuyen + ' AND ' + sql
        }
        else {
            sql = props.queryHuyen;
        }
        return sql;
    }

    const exportExcel = (data) => {
        const sql = getSql(data);
        props.exportExcel(sql);
    }

    const clickTab = (k) => {
    }


    const loadDuLieu = () => {
        props.timKiemLoading(true);
        const params = {
            pageIndex: pageIndex,
            tableName: 'BDTHICHHOPSUDUNGDAT',
            sql: query
        }
        BanDoThichHopApi.getPaging(params).then((res) => {
            setKetQua(res.Items);
            paginationConfig.totalPages = (Math.ceil(res.TotalRow / 20) === 0 ? 1 : Math.ceil(res.TotalRow / 20));
            paginationConfig.currentPage = pageIndex;
            setTongRow(res.TotalRow);
            setTongDienTich(res.TongDienTich);
            paginationConfig.onClick = function (page) {
                pageIndex = page;
                loadDuLieu();
            }
            setPaging(paginationConfig);
            props.timKiemLoading(false);
        }, (err) => {
            props.timKiemLoading(false);
        })
    }

    const clickRow = (id) => {
        props.timKiemGetChiTiet({
            id: id,
            tableName: 'BDTHICHHOPSUDUNGDAT'
        })
    }

    const [paginationConfig, setPaging] = useState({
        totalPages: 1,
        currentPage: 1,
        showMax: 5,
        size: "sm",
        threeDots: true,
        prevNext: true,
        onClick: function (page) {
            pageIndex = page;
            loadDuLieu();
        }
    });

    return (
        <Tabs defaultActiveKey="timkiem" onSelect={(k) => clickTab(k)}>
            <Tab eventKey="timkiem" title="Tìm kiếm">
                <form className="frmtimkiem">
                    {/* <div className="form-group row">
                        <label className="col-sm-4 col-form-label text-right">Tên xã</label>
                        <div className="col-sm-8">
                            <input name="TenXa" type="text" className="form-control" placeholder="Tên xã" ref={register} />
                        </div>
                    </div> */}
                    {/* <div className="form-group row">
                        <label className="col-sm-4 col-form-label text-right">Mã thích hợp</label>
                        <div className="col-sm-8">
                            <input name="maThichHop" type="text" className="form-control" placeholder="Nhập mã thích hợp" ref={register} />
                        </div>
                    </div> */}
                    <div className="form-group row tkdientich">
                        <div className="col-sm-3">
                            <input name="DienTichMin" type="number" className="form-control" placeholder="ha" ref={register} />
                        </div>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="DienTichDieuKienMin" ref={register}>
                                <option value=">">&#60;</option>
                                <option value=">=">&#60;&#61;</option>
                            </select>
                        </div>
                        <label className="col-sm-2 col-form-label text-center">Diện tích</label>
                        <div className="col-sm-2 select-dt">
                            <select class="form-control" name="DienTichDieuKienMax" ref={register}>
                                <option value="<">&#60;</option>
                                <option value="<=">&#60;&#61;</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <input name="DienTichMax" type="number" className="form-control" placeholder="ha" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Hồ tiêu</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThTieu" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Cafe</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThCafe" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Cao su</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThCaoSu" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Điều</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThDieu" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>                    
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Lúa</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThLua" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Ngô</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThNgo" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Sắn</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThSan" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Khoai</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThKhoai" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Rau</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThRau" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Dược liệu</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThDuoc" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Bơ</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThBo" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Sầu riêng</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThSauRieng" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Bí</label>
                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThBi" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Lạc</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThLac" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Hoa</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThHoa" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Cam</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThCam" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">

                        <label className="col-sm-3 col-form-label text-right">Bưởi</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThBuoi" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Chanh dây</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThChanh" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Nhãn</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThNhan" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>

                    </div>

                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Mít</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThMit" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">

                        <label className="col-sm-3 col-form-label text-right">Xoài</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThXoai" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Na</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThNa" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>

                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Chuối</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThChuoi" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Dâu tằm</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThDauTam" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Măng tây</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThMang" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label text-right">Dứa</label>

                        <div className="col-sm-8 select-dt">
                            <select class="form-control" name="ThDua" ref={register}>
                                <option value="">Chọn thích hợp</option>
                                <option value="S1">Thích hợp cao</option>
                                <option value="S2">Thích hợp trung bình</option>
                                <option value="S3">Kém thích hợp</option>
                                <option value="N">Không thích hợp</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-12 text-right">
                            <Button variant="info mr-1" size="sm" onClick={handleSubmit(exportExcel)}><i className="fas fa-file-excel"></i> Excel</Button>
                            <Button variant="success" size="sm" onClick={handleSubmit(timKiem)}><i className="fas fa-search"></i> Tìm kiếm</Button>
                        </div>
                    </div>
                    {
                        tongRow > -1 ?
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label text-right">Kết quả:</label>
                                <div className="col-sm-8">
                                    <h5 className="ket-qua-tim-kiem"><NumberFormat value={tongRow} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat> khoảnh đất</h5>
                                </div>
                                <label className="col-sm-4 col-form-label text-right">Tổng diện tích:</label>
                                <div className="col-sm-8">
                                    <h5 className="ket-qua-tim-kiem"><NumberFormat value={tongDienTich} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat> ha</h5>
                                </div>
                            </div> : ''
                    }
                </form>
            </Tab>
            <Tab eventKey="ketqua" title="Kết quả">
                {
                    <>
                        <table className="table table-bordered tb-chu-giai" width="100%">
                            <thead>
                                <tr>
                                    <th>Xã</th>
                                    <th>Mã thích hợp</th>
                                    <th>Diện tích</th>

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    listKetQuas.length === 0 ? <tr>
                                        <td colSpan="100%">Không có bản ghi được tìm thấy</td>
                                    </tr> :
                                        listKetQuas.map((item, key) => {
                                            return (
                                                <tr key={key} onClick={() => clickRow(item.id)}>
                                                    <td>{item.tenxa}</td>
                                                    <td>{item.ma}</td>
                                                    <td>
                                                        <NumberFormat value={item.dt_ha} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat>
                                                    </td>

                                                </tr>
                                            )
                                        })
                                }
                            </tbody>
                        </table>
                        <Pagination {...paginationConfig} />
                    </>
                }
            </Tab>
        </Tabs>

    )
}
